import React from 'react';
import cn from 'classnames';

import { withRouter, NextRouter } from 'next/router';
import styles from './BackButton.module.scss';

interface BackButtonProps {
  router: NextRouter;
  goBack?: () => void;
  img?: string;
  className?: string;
}

export const BackButton: React.FC<BackButtonProps> = ({ router, goBack, img = 'Back', className }) => {
  const back = goBack || router.back;
  return (
    <div
      className={cn(styles.BackButton, className)}
      onClick={back}
      data-cy="page-back-button"
      data-testid="page-back-button"
    >
      <img src={`/img/buttons/${img}.svg`} alt="back" />
    </div>
  );
};



export default withRouter(BackButton);
